import {
    ADD_TEMPLATE,
    GET_TEMPLATE,
    EDIT_TEMPLATE,
    ALL_TEMPLATE
  } from "./actionTypes"
  
  export const addTemplate = (template,history) => {
    return {
      type: ADD_TEMPLATE,
      payload: { template,history},
    }
  }

  export const getTemplate = (data) => {
    return {
      type: GET_TEMPLATE,
      payload: { data },
    }
  }

  export const allTemplate = template => {
    return {
      type: ALL_TEMPLATE,
      payload: template,
    }
  }

  export const editTemplate = (template,history) => {
    return {
      type: EDIT_TEMPLATE,
      payload:{template,history},
    }
  }